// src/components/AdvisorLink.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AdvisorLink = ({ advisor }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/submissions', { state: { selectedAdvisor: advisor.name } });
  };

  return (
    <p
      className='text-base text-body-color dark:text-dark-6 cursor-pointer'
      onClick={handleClick}
    >
      {advisor.referral_count || 0}
    </p>
  );
};

export default AdvisorLink;